<template>
  <div class="main_form_body">
    <div class="form_bar" style="align-self: flex-end; width: 100%">
      <div class="form_bar_search"></div>
      <div class="form_bar_btn">
        <el-button type="text" @click="goBack()">问卷列表</el-button>
        <el-button
          type="primary"
          @click="editQuestionnaire('basicForm', false)"
          size="small"
        >
          保存
        </el-button>
        <el-button
          type="primary"
          @click="editQuestionnaire('basicForm', true)"
          size="small"
          :disabled="questionnaireInfo.State !== 0"
        >
          下一步
        </el-button>
      </div>
    </div>
    <div class="form_content" style="flex-grow: 1; width: 100%">
      <div class="main_form">
        <el-form
          :model="basicForm"
          :rules="basicFormRules"
          ref="basicForm"
          label-width="130px"
          class="demo-ruleForm"
          v-loading="editLoading"
          :label-position="is_xs ? 'top' : 'right'"
        >
          <el-form-item label="问卷名称：" prop="Name">
            <el-row>
              <el-col :xs="24" :sm="24" :md="18" :lg="14" :xl="14">
                <el-input v-model="basicForm.Name"></el-input>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="问卷类型：" prop="Type">
            <el-row>
              <el-col :xs="24" :sm="24" :md="18" :lg="14" :xl="14">
                <el-radio-group v-model="basicForm.Type" size="small">
                  <el-radio-button :label="1"> 考试 </el-radio-button>
                  <el-radio-button :label="2" v-show="false">
                    调查
                  </el-radio-button>
                  <!-- <el-radio-button :label="3">投票</el-radio-button>
                  <el-radio-button :label="4">表单</el-radio-button> -->
                </el-radio-group>
              </el-col>
            </el-row>
          </el-form-item>
          <el-divider v-if="basicForm.Type === 1"></el-divider>
          <el-form-item
            label="时间控制："
            prop="IsLimitTime"
            v-if="basicForm.Type === 1"
          >
            <el-row>
              <el-col :xs="24" :sm="24" :md="18" :lg="14" :xl="14">
                <el-switch v-model="basicForm.IsLimitTime"> </el-switch>
                <i
                  class="el-icon-warning-outline"
                  style="margin-left: 20px"
                ></i>
                开启时间控制，可以控制答卷的开始时间及时长。
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item
            label="开始时间："
            prop="StartTime"
            v-if="basicForm.IsLimitTime"
          >
            <el-row>
              <el-col :xs="24" :sm="24" :md="18" :lg="14" :xl="14">
                <el-date-picker
                  v-model="basicForm.StartTime"
                  type="datetime"
                  format="yyyy-MM-dd HH:mm"
                  placeholder="选择开始日期时间"
                  default-time="9:00:00"
                  :z-index="9000"
                >
                </el-date-picker>
                <br />
                <i class="el-icon-warning-outline"></i>
                该处设置时间，所有填写问卷人员的开始时间一致；该处不设置时间（设置为空），问卷人员开始时间以第一次打开问卷计算。
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item
            label="限制时长："
            prop="TimeDuration"
            v-if="basicForm.IsLimitTime"
          >
            <el-row>
              <el-col :xs="24" :sm="24" :md="18" :lg="14" :xl="14">
                <el-input-number
                  v-model="basicForm.TimeDuration"
                  :min="0"
                  :precision="0"
                ></el-input-number>
                （分钟）
              </el-col>
            </el-row>
          </el-form-item>
          <el-divider></el-divider>
          <el-form-item
            label="及格设置："
            prop="IsSetPassScore"
            v-if="basicForm.Type === 1"
          >
            <el-row>
              <el-col :xs="24" :sm="24" :md="18" :lg="14" :xl="14">
                <el-switch v-model="basicForm.IsSetPassScore"> </el-switch>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item
            label="及格分数："
            prop="PassScore"
            v-if="basicForm.Type === 1 && basicForm.IsSetPassScore"
          >
            <el-row>
              <el-col :xs="24" :sm="24" :md="18" :lg="14" :xl="14">
                <el-input-number
                  v-model="basicForm.PassScore"
                  :min="0"
                  :precision="2"
                  :controls="false"
                ></el-input-number>
              </el-col>
            </el-row>
          </el-form-item>
          <el-divider v-if="basicForm.Type === 1"></el-divider>
          <el-form-item label="选项排号方式：" prop="OptionSerialNumberType">
            <el-row>
              <el-col :xs="24" :sm="24" :md="18" :lg="14" :xl="14">
                <el-radio-group v-model="basicForm.OptionSerialNumberType">
                  <el-radio :label="2">大写字母</el-radio>
                  <el-radio :label="3">小写字母</el-radio>
                  <el-radio :label="1">数字</el-radio>
                </el-radio-group>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="简介：" prop="Description" v-if="false">
            <el-row>
              <el-col :xs="24" :sm="24" :md="20" :lg="20" :xl="20">
                <VueUeditorWrap
                  ref="descriptionEditor"
                  v-model="basicForm.Description"
                  :config="ueditorConfig"
                ></VueUeditorWrap>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="顶部封面：" prop="Cover" v-if="false">
            <el-row>
              <el-col :xs="24" :sm="24" :md="20" :lg="20" :xl="20">
                <VueUeditorWrap
                  ref="coverEditor"
                  v-model="basicForm.Cover"
                  :config="ueditorConfig"
                ></VueUeditorWrap>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="欢迎文字：" prop="WelcomeWord">
            <el-row>
              <el-col :xs="24" :sm="24" :md="20" :lg="20" :xl="20">
                <el-input
                  type="textarea"
                  placeholder="请输入内容"
                  v-model="basicForm.WelcomeWord"
                  maxlength="2000"
                  show-word-limit
                  rows="3"
                >
                </el-input>
              </el-col>
            </el-row>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import questionnaireApi from '../../../../api/wj/questionnaire'
import ueditorConfig from '../../../../assets/js/ueditorConfig_simple'
import VueUeditorWrap from 'vue-ueditor-wrap'
export default {
  name: 'editBasic',
  components: {
    VueUeditorWrap
  },
  data () {
    return {
      editLoading: false,
      basicForm: {
        Id: null,
        MeetingID: null,
        Name: null,
        Type: 1,
        Description: null,
        WelcomeWord: null,
        CoverPictureUrl: null,
        PublishTime: null,
        IsLimitTime: false,
        StartTime: null,
        TimeDuration: null,
        IsSetPassScore: false,
        PassScore: null,
        OptionSerialNumberType: 2
      },
      basicFormRules: {
        Name: [
          { required: true, message: '请输入问卷名称', trigger: 'blur' },
          { min: 1, max: 200, message: '长度在 1 到 200 个字符', trigger: 'blur' }],
        Type: [
          { required: true, message: '请选择问卷类型', trigger: 'blur' }],
        WelcomeWord: [
          { min: 1, max: 2000, message: '长度在 1 到 2000 个字符', trigger: 'blur' }],
        OptionSerialNumberType: [
          { required: true, message: '请选择选项序号方式', trigger: 'blur' }]
      },
      ueditorConfig: ueditorConfig
    }
  },
  props: ['questionnaireInfo'],
  inject: ['checkQuestionnaire', 'getQuestionnaireInfo', 'routeChange'],
  methods: {
    goBack: function () {
      this.$router.push({ name: 'questionnaireManage', params: { mid: this.$route.params.mid } })
    },
    getQuestionnaireBasicInfo: function () {
      this.editLoading = true
      questionnaireApi.getQuestionnaireBasicInfo({
        questionnaireId: this.$route.params.qid
      }).then(data => {
        this.basicForm = data
        this.editLoading = false
      }).catch(err => {
        this.editLoading = false
        return err
      })
    },
    editQuestionnaire: function (formName, isNext) {
      const _this = this
      _this.$refs[formName].validate((valid) => {
        if (valid) {
          const openLoading = _this.openLoading('正在保存…')
          if (_this.basicForm.StartTime) {
            _this.basicForm.StartTime = _this.$moment(_this.basicForm.StartTime).format('YYYY-MM-DD HH:mm')
          }
          questionnaireApi.editQuestionnaireBasic(_this.basicForm).then(data => {
            _this.basicForm.Id = data.Id
            openLoading.close()
            _this.$message({
              showClose: true,
              type: 'success',
              message: '保存成功！',
              customClass: 'custom_message'
            })

            if (isNext) {
              if (this.$route.name.indexOf('create') !== -1) {
                if (this.questionnaireInfo.MeetingVerify === 1) {
                  _this.$router.push({ name: 'createQuestionnaireBody', params: { mid: _this.basicForm.MeetingID, qid: data.Id } })
                } else {
                  _this.$router.push({ name: 'createQuestionnaireUser', params: { mid: _this.basicForm.MeetingID, qid: data.Id } })
                }
              } else {
                if (this.questionnaireInfo.MeetingVerify === 1) {
                  _this.$router.push({ name: 'editQuestionnaireBody', params: { mid: _this.basicForm.MeetingID, qid: data.Id } })
                } else {
                  _this.$router.push({ name: 'editQuestionnaireUser', params: { mid: _this.basicForm.MeetingID, qid: data.Id } })
                }
              }
            } else {
              if (this.$route.name.indexOf('create') !== -1) {
                _this.$router.push({ name: 'createQuestionnaireBasic', params: { mid: _this.basicForm.MeetingID, qid: data.Id } })
              } else {
                _this.$router.push({ name: 'editQuestionnaireBasic', params: { mid: _this.basicForm.MeetingID, qid: data.Id } })
              }
              this.checkQuestionnaire()
              this.getQuestionnaireInfo()
              this.getQuestionnaireBasicInfo()
            }
          }).catch(err => {
            openLoading.close()
            return err
          })
        } else {
          return false
        }
      })
    }
  },
  computed: {

  },
  created () {
    if (this.$route.params.qid === '0') {
      this.basicForm.MeetingID = this.$route.params.mid
    } else {
      this.getQuestionnaireBasicInfo()
    }
    this.routeChange()
    this.checkQuestionnaire()
  },
  watch: {
    $route () {
      if (this.$route.name === 'createQuestionnaireBasic' && this.$route.params.qid === '0') {
        this.basicForm = {
          Id: null,
          MeetingID: null,
          Name: null,
          Type: 1,
          Description: null,
          WelcomeWord: null,
          CoverPictureUrl: null,
          PublishTime: null,
          IsLimitTime: false,
          StartTime: null,
          TimeDuration: null,
          IsSetPassScore: false,
          PassScore: null,
          OptionSerialNumberType: 2
        }
      }
    }
  }
}
</script>
<style lang="less">
.el-picker-panel {
  z-index: 9002 !important;
}
</style>
